import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import PageBanner from '../layout/PageBanner';
import { companyInfo } from '../../data/company';

const ContactPage = () => {
  return (
    <div>
      <PageBanner
        title="Contact Us"
        breadcrumbs={[{ label: 'CONTACT US' }]}
      />

      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="text-3xl font-serif font-bold mb-8">Get In Touch</h2>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary-red rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-1">OUR LOCATION</h3>
                    <p className="text-gray-600">
                      {companyInfo.name}<br />
                      {companyInfo.location}
                    </p>
                    <p className="text-gray-600 mt-2">
                      Phone: {companyInfo.phone}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary-red rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-1">EMAIL US</h3>
                    <a
                      href={`mailto:${companyInfo.email}`}
                      className="text-primary-red hover:underline"
                    >
                      {companyInfo.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Reach Us Directly */}
            <div className="bg-gray-50 p-8 rounded-lg flex flex-col justify-center">
              <h2 className="text-2xl font-serif font-bold mb-3">Give Us a Call</h2>
              <p className="text-gray-600 mb-8">
                We&apos;d love to hear from you. Reach our team directly by
                phone or email.
              </p>

              <a
                href={`tel:${companyInfo.phone.replace(/[^\d+]/g, '')}`}
                className="flex items-center gap-4 mb-4 group"
              >
                <div className="w-12 h-12 bg-primary-red rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-1">CALL US</h3>
                  <span className="text-primary-red text-xl font-semibold group-hover:underline">
                    {companyInfo.phone}
                  </span>
                </div>
              </a>

              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-4 group"
              >
                <div className="w-12 h-12 bg-primary-red rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-lg mb-1">EMAIL US</h3>
                  <span className="text-primary-red group-hover:underline">
                    {companyInfo.email}
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
